export function useGetImage() {
	return {
		getHomeImage: (name: string) => require(`@/assets/images/view-home/${name}.png`),
		getQuestionsImage: (name: string) => require(`@/assets/images/view-questions/${name}.png`)
	};
}
